import React, { useCallback, useMemo, useState } from 'react';
import { Toast } from 'antd-mobile';
import copy from 'copy-to-clipboard';
import {
  BOUNS_CARD_CLASSNAME,
  BOUNS_DEVICE_LIMIT,
  BOUNS_EXPIRED_STATUS,
  BOUNS_UNUSED_STATUS,
  BOUNS_USED_STATUS,
  BOUNS_USING_STATUS,
} from '../../config';
import styles from '../../styles/bonus.less';

const BounsCard = ({
  handleCardClick,
  data: {
    deviceAccountId,
    cardCode,
    availableDevice,
    cardName,
    description,
    rewardDay,
    rewardRate,
    sn,
    status,
    rewardEndTime,
    useEndTime,
    rewardTime,
    useStartTime,
  },
}) => {
  const isUnusedStatus = useMemo(() => status === BOUNS_UNUSED_STATUS, [status]);
  const [isRuleFlat, setIsRuleFlat] = useState(false);
  const handleCopySN = useCallback(
    e => {
      e.stopPropagation();
      copy(sn);
      Toast.info('复制成功');
      // reportClick({
      //   page_name: PAGE_NAME,
      //   button_name: 'copy_btn',
      // });
    },
    [sn]
  );

  const handleRuleClick = useCallback(
    e => {
      e.stopPropagation();
      setIsRuleFlat(!isRuleFlat);
    },
    [isRuleFlat]
  );

  const renderBounsCardTime = useCallback(() => {
    let timeStr = '';
    switch (status) {
      case BOUNS_UNUSED_STATUS:
        timeStr = `有效期：${useStartTime}至${useEndTime}`;
        break;
      case BOUNS_EXPIRED_STATUS:
        timeStr = `${useEndTime}失效`;
        break;
      case BOUNS_USING_STATUS:
        timeStr = `加成期至：${rewardEndTime}`;
        break;
      case BOUNS_USED_STATUS:
        timeStr = `有效期至：${rewardEndTime}`;
        break;
      default:
        timeStr = '--';
        break;
    }
    return timeStr;
  }, [status, rewardEndTime, useEndTime, useStartTime]);

  return (
    <li
      className={`${styles.bonusCard} ${styles[BOUNS_CARD_CLASSNAME[status]]}`}
      onClick={() => handleCardClick({ status, cardCode, deviceAccountId })}
    >
      <div className={styles.cardInfo}>
        <div className={styles.infoLeft}>
          <h3 className={styles.cardName}>
            {rewardRate}%{cardName}
          </h3>
          <p className={styles.date}>{renderBounsCardTime()}</p>
          {sn && (
            <p className={styles.device}>
              使用设备SN：{sn}
              <i className={styles.copy} onClick={handleCopySN} />
            </p>
          )}
        </div>
        <div className={styles.infoRight}>
          <h3 className={styles.cardTime}>{rewardDay}天</h3>
          <p className={styles.cardText}>{BOUNS_DEVICE_LIMIT[availableDevice]}</p>
        </div>
      </div>
      <div className={styles.cardInfo}>
        <div className={`${styles.ruleText} ${isRuleFlat ? styles.flat : ''}`}>
          <p className={styles.ruleBtn} onClick={handleRuleClick}>
            使用规则
          </p>
          <div className={styles.ruleHtml} dangerouslySetInnerHTML={{ __html: description }} />
        </div>
        {isUnusedStatus && <span className={styles.useBtn}>去使用</span>}
      </div>
    </li>
  );
};
export default BounsCard;
